'use client';

import Script from 'next/script';
import { Suspense } from 'react';
import GoogleTagManagerTracker from './GoogleTagManagerTracker';

// Using the DataLayerItem type defined in src/types/gtm.d.ts
declare global {
  interface Window {
    dataLayer: DataLayerItem[];
  }
}

export default function GoogleTagManager({ gtmId }: { gtmId: string }) {
  if (!gtmId) {
    return null;
  }

  return (
    <>
      {/* Google Tag Manager - Script */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
          `,
        }}
      />
      <Suspense fallback={null}>
        <GoogleTagManagerTracker />
      </Suspense>
    </>
  );
}
